
// Encode entire object into a single Base64 string
export function encryptUrlParams(obj: any): string {
  const json = JSON.stringify(obj);
  const base64 = btoa(json); // encode JSON to Base64
  return encodeURIComponent(base64); // safe for URL
}

// Decode Base64 string back to object
export function decryptUrlParams(encoded: string): any {
  const decoded = decodeURIComponent(encoded);
  const json = atob(decoded);
  return JSON.parse(json);
}
